module.exports = __webpack_public_path__ + "static/dunlop-a74156fa4675a62c520b6abf231b9cfe.png";